import React from 'react';
import { isMobile } from "react-device-detect";
import globals from '../globals';
import CustomLink from "../elements/CustomLink";

const NavItem = (props) => {

    const renderChildren = props.children.map((item) => {
        return (
            <li key={globals.convertToSlug(item.title)}>
                <CustomLink
                    to={item.url}
                    className={item.active}
                    dangerouslySetInnerHTML={{__html: item.title}}
                    onClick={(event) => {handlePageChange(event, item)}}
                />
            </li>
        );
    });

    const pushEventNavClick = (item) => {
        globals.pushGA4Events('navClick', {
            eventInfo: {
                navType: item ? 'Secondary Nav Menu' : 'Primary Nav Menu',
                clickText: item ? item.title : props.title,
                clickUrl: window.location.origin + (item ? item.url : props.url),
                pageCategory: 'Business'
            }
        })
    }

    const handleShowSubNav = (event) => {
        event.preventDefault();
        if (props.handleShowSubNav) {
            props.handleShowSubNav(event, props.title, props.identifier);
        }
        pushEventNavClick()
    };

    const handlePageChange = (event, item) => {
        if (props.handlePageChange) {
            props.handlePageChange(event);
        }
        pushEventNavClick(item)
    };

    if (props.children.length > 0 && !props.isFooter) {
        const MobileNav = () => {
            return (
                <li>
                    <a
                        href="#"
                        className={props.active}
                        dangerouslySetInnerHTML={{__html: props.title}}
                        onClick={handleShowSubNav.bind(this)}
                    />
                </li>
            );
        };

        const DesktopNav = () => {
            return (
                <li className='nav-dropdown-list'>
                    <CustomLink
                        to={props.url}
                        className={'hover-left ' + props.active}
                        dangerouslySetInnerHTML={{__html: props.title}}
                        onClick={handlePageChange}
                    />
                        <ul className="nav-dropdown">
                            {!isMobile ? renderChildren : ''}
                        </ul>
                </li>
            );
        };

        return (
            isMobile ? MobileNav() : DesktopNav()
        );
    } else {
        return (
            <li>
                <CustomLink
                    to={props.url}
                    className={'hover-left ' + props.active}
                    onClick={handlePageChange}
                >
                    {props.title}
                </CustomLink>
            </li>
        );
    }

}

export default NavItem;


// WEBPACK FOOTER //
// ./resources/assets/js/layout/NavItem.js